import React from 'react'
import { Badge } from 'reactstrap'
import { modes } from '@/components/changeRequests/propertyRenderer'
import { useLocalization } from '@/hooks/localization'

const ApprovalBadges = React.memo(function ApprovalBadges ({ badges, mode }) {
  return (
    <React.Fragment>
      <ApprovalBadge color='danger' count={badges.rejected} title='Tasks.RejectedCount' />
      {mode !== modes.edit && <ApprovalBadge color='success' count={badges.approved} title='Tasks.ApprovedCount' />}
      {mode !== modes.edit && <ApprovalBadge color='warning' count={badges.pending} title='Tasks.PendingCount' />}
    </React.Fragment>
  )
})

function ApprovalBadge ({ count, color, title }) {
  const { localize } = useLocalization()
  return count > 0
    ? <React.Fragment>&nbsp;<Badge color={color} pill title={localize(title)}>{count}</Badge></React.Fragment>
    : null
}

export {
  ApprovalBadges
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/approvalBadges.js